var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"text-danger list-unstyled mb-1"},_vm._l((_vm.error_bag),function(errorField,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(errorField)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }